import { IconButton, Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const HomeBrandSliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

const BrandImage = styled(Image)`
  border: 10px solid var(--color-accent-primary-weaker);
  border-radius: var(--size-border-radius-circle);
  object-fit: cover;
`;

const BrandLogo = styled(Image)`
  max-height: 48px;
  max-width: 140px;
`;

const BrandItem = styled.div`
  align-items: center;
  border-radius: var(--size-border-radius-circle);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  text-align: center;
  transition: all 0.2s ease-in-out;

  &:hover ${BrandImage} {
    box-shadow: var(--shadow-m);
  }
`;

const HomeBrandSlider = styled.div`
  align-items: center;
  display: flex;
  margin-top: 24px;

  .swiper-button-disabled {
    display: none;
  }
`;

const NavigationButton = styled(IconButton)`
  background-color: var(--color-bg-default);
  box-shadow: var(--shadow-m);
  cursor: pointer;
  height: 32px;
  width: 32px;
`;

const BrandSkeleton = styled.div`
  align-items: center;
  display: flex;
`;

const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;

export {
  BrandImage,
  BrandItem,
  BrandLogo,
  BrandSkeleton,
  HeaderWrapper,
  HomeBrandSlider,
  HomeBrandSliderWrapper,
  NavigationButton
};
